import React from "react";
import SeoMetadata from '../components/Seo/SeoMetadata';
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";
import TituloRecubrimientoPisos from "../components/sections/RecubrimientosPisos/TituloRecubrimientoPisos";
import CatalogoPisos from "../components/sections/RecubrimientosPisos/CatalogoPisos";
import IntroPisos from "../components/sections/RecubrimientosPisos/IntroPisos";
import FormularioPisos from "../components/sections/RecubrimientosPisos/FormularioPisos";

const RecubrimientosPisos = () => {
    return (
        <div>
            <SeoMetadata
                title="Recubrimientos para Pisos | Decototal"
                description="Encuentra recubrimientos para pisos y soluciones para distintos espacios y necesidades. Explora el catálogo y cotiza con Decototal."
                keywords="recubrimientos para pisos, pisos decorativos, pisos para interiores, pisos para exteriores"
                path="/recubrimientos-pisos"
                image="/assets/img/productos/piso-caucho-reciclado/piso-caucho-catalogo-azul-titulo.jpg"
            />
            <Header />
            <TituloRecubrimientoPisos />
            <CatalogoPisos />
            <IntroPisos />
            <FormularioPisos />
            <Footer />
        </div>
    );
};

export default RecubrimientosPisos;